import { ArchiveRemoveIcon } from './ArchiveRemoveIcon';

/**
 * author: Colton Wiscombe
 * id F856A6DD-E894-4B78-BE97-4239C01CECF7
 * name archive-remove
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-remove.svg
 * tags
 */
export const BoxRemoveIcon = ArchiveRemoveIcon;
export default BoxRemoveIcon